import { thunk, ThunkDispatch } from 'redux-thunk';
import {
  createStore,
  compose,
  applyMiddleware,
  combineReducers,
  Reducer,
  AnyAction,
  Action,
} from 'redux';
import persist, { loadState } from './middleware/persist';
import { ConfigState, reducer as config } from './config';
import { AuthState, reducer as auth } from './auth';
import { ConsentsState, reducer as consents } from './consents';
import eventsMiddleware from './middleware/events';
import tracker from './middleware/tracker';
import scroller from './middleware/scroller';

export const RESET = 'RESET';

export type RootState = {
  auth: AuthState;
  config: ConfigState;
  consents: ConsentsState;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const appReducer: Reducer<RootState> = combineReducers({
  config,
  auth,
  consents,
});

const rootReducer = (
  state: RootState,
  action: AnyAction,
) => appReducer(action.type === RESET ? loadState() : state, action);

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore<RootState, AnyAction, {
  dispatch: ThunkDispatch<RootState, void, Action>
}, unknown>(
  rootReducer,
  undefined,
  composeEnhancers(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    applyMiddleware(thunk, persist, eventsMiddleware, tracker, scroller),
  ),
);

export type AppDispatch = typeof store.dispatch;

export default store;
